import { SimpleTableComponent } from '@shared/components/simple-table/simple-table.component';
import { TableHeaderComponent } from '@shared/components/simple-table/components/table-header/table-header.component';
import { MobileTableComponent } from '@shared/components/simple-table/components/mobile-table/mobile-table.component';
import { TableCellComponent } from '@shared/components/simple-table/components/table-cell/table-cell.component';
import { SortableHeaderComponent } from '@shared/components/simple-table/components/sortable-header/sortable-header.component';
import { StatusColumnComponent } from '@shared/components/simple-table/components/status-column/status-column.component';
import { ActionButtonComponent } from '@shared/components/simple-table/components/action-button/action-button.component';
import { BooleanColumnComponent } from '@shared/components/simple-table/components/boolean-column/boolean-column.component';
import { IdentificationColumnComponent } from '@shared/components/simple-table/components/identification-column/identification-column.component';
import { WorkflowColumnComponent } from '@shared/components/simple-table/components/workflow-column/workflow-column.component';
import { ChipsColumnComponent } from '@shared/components/simple-table/components/chips-column/chips-column.component';
import { ZButtonComponent } from '@shared/components/z-button/z-button.component';
import { ZDialogComponent } from '@shared/components/z-dialog/z-dialog.component';
import { ZFilterBarComponent } from '@shared/components/z-filter-bar/z-filter-bar.component';
import { ZInputComponent } from '@shared/components/z-input/z-input.component';
import { ZInputPasswordComponent } from '@shared/components/z-input-password/z-input-password.component';
import { ZSelectComponent } from '@shared/components/z-select/z-select.component';
import { ZFormGridComponent } from '@shared/components/z-form-grid/z-form-grid.component';
import { PaginatorComponent } from '@shared/components/paginator/paginator.component';
import { ExpandableTableComponent } from '@shared/components/expandable-table/expandable-table.component';
import { TitleComponent } from '@shared/components/title/title.component';
import { FormDialogComponent } from '@shared/components/form-dialog/form-dialog.component';
import { MessageDialogComponent } from '@shared/components/message-dialog/message-dialog.component';
import { CardVariantComponent } from '@shared/components/cards/card-variant/card-variant.component';
import { DatePickerComponent } from '@shared/components/dates/datepicker/datepicker.component';
import { MonthPickerComponent } from '@shared/components/dates/monthpicker/monthpicker.component';
import { EmptyDataComponent } from '@shared/components/empty-data/empty-data.component';
import { FileUploaderComponent } from '@shared/components/file-uploader/file-uploader.component';
import { FileUploaderItemComponent } from '@shared/components/file-uploader/components/file-uploader-item/file-uploader-item.component';
import { FilterDialogComponent } from '@shared/components/filter-dialog/filter-dialog.component';
import { InfoCardComponent } from '@shared/components/info-card/info-card.component';
import { SummaryDialogComponent } from '@shared/components/summary-dialogs/summary-dialogs.component';
import { WidgetDataListComponent } from '@shared/components/widget-data-list/widget-data-list.component';
import { AvatarCellComponent } from '@shared/components/avatar-cell/avatar-cell.component';
import { HistoryDialog } from '@shared/components/history-dialog/history-dialog.component';
import { AttachDocumentsDialog } from '@shared/components/attach-documents-dialog/attach-documents-dialog.component';
import { EditEmailDialog } from '@shared/components/edit-email-dialog/edit-email-dialog.component';
import { ReproveDialog } from '@shared/components/reprove-dialog/reprove-dialog.component';
import { SendSignedDocDialog } from '@shared/components/send-signed-doc-dialog/send-signed-doc-dialog.component';
import { CurrentAccountDialogComponent } from '@shared/components/current-account-dialog/current-account-dialog.component';
import { WorkflowActionDialogComponent } from '@shared/components/workflow-action-dialog/workflow-action-dialog.component';

import { ColumnStatusPipe } from '@shared/components/simple-table/components/status-column/pipes/column-status.pipe';
import * as PipesNamespace from '@shared/pipes';
import { ApproveDialogComponent } from '@shared/components/approve-dialog/approve-dialog.component';
import { HasRoleDirective } from '@shared/directives/has-role.directive';

export const declarations = [
    SimpleTableComponent,
    TableHeaderComponent,
    MobileTableComponent,
    TableCellComponent,
    SortableHeaderComponent,
    StatusColumnComponent,
    ActionButtonComponent,
    BooleanColumnComponent,
    IdentificationColumnComponent,
    WorkflowColumnComponent,
    ChipsColumnComponent,
    ZButtonComponent,
    ZDialogComponent,
    ZFilterBarComponent,
    ZInputComponent,
    ZInputPasswordComponent,
    ZSelectComponent,
    ZFormGridComponent,
    PaginatorComponent,
    ExpandableTableComponent,
    TitleComponent,
    FormDialogComponent,
    MessageDialogComponent,
    CardVariantComponent,
    DatePickerComponent,
    MonthPickerComponent,
    EmptyDataComponent,
    FileUploaderComponent,
    FileUploaderItemComponent,
    FilterDialogComponent,
    HistoryDialog,
    InfoCardComponent,
    SummaryDialogComponent,
    WidgetDataListComponent,
    ColumnStatusPipe,
    AttachDocumentsDialog,
    EditEmailDialog,
    ReproveDialog,
    SendSignedDocDialog,
    CurrentAccountDialogComponent,
    WorkflowActionDialogComponent,
    ApproveDialogComponent,
    AvatarCellComponent,
    PipesNamespace.EmptyValuePipe,
    PipesNamespace.TruncatePipe,
    PipesNamespace.FileSizePipe,
    PipesNamespace.TelefonePipe,
    HasRoleDirective
];
